<template lang='pug'>
.listing-container
  .row
    .col-12.col-lg-6(v-for='product, index in products' :key='index')
      product-card(
        :product='product'
        :variants='variantList(product)'
        size='sm'
      )
</template>
<script>
import ProductCard from '../../../products/product-card.vue'

export default {
  components: {
    ProductCard
  },
  props: {
    products: {
      type: Array,
      default: () => [],
      required: true
    },
    variants: {
      type: Array,
      default: () => [],
      required: true
    }
  },

  methods: {
    variantList (product) {
      return this.variants.filter(variant => variant.relationships.product.data.id === product.id)
    }
  }
}
</script>

<style lang='scss' scoped>
  .listing-container {
    width: 100%;
    margin-bottom: 20px;
  }
</style>

<style lang='scss'>
  .out-of-stock.icon-sm {
    box-sizing: border-box;
    padding-top: 15px;
  }

  img.product-variant {
    vertical-align: top;
  }
</style>
